import Container from "react-bootstrap/Container";
import Button from "react-bootstrap/Button";
import { Row, Col } from "react-bootstrap";
import Faq from "../components/Faq";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCheck,
  faGraduationCap,
  faSackDollar,
  faChartLine,
  faTrophy,
  faMapLocationDot,
  faHandshake,
} from "@fortawesome/free-solid-svg-icons";
import "../styles/dualEducation.css";
import FormSection from "../components/formsection";
import TileGrid from "../components/TileGrid";
import ResultsSection from "../components/ResultSection";

const SERVICES = [
  {
    icon: faGraduationCap,
    title: "Duális képzés",
    description: "Állami támogatással segítünk a duális képzési programok elindításában.",
    to: "/dualis-kepzes",
  },
  {
    icon: faSackDollar,
    title: "Vállalati hitel",
    description: "Bankfüggetlen hiteltanácsadás és ajánlatkérés cégeknek.",
    to: "/vallalati-hitel",
  },
  {
    icon: faChartLine,
    title: "Számlaoptimalizálás",
    description: "Vállalati bankszámla és díjstruktúra optimalizálása.",
    to: "/szamlaoptimalizalas",
  },
  {
    icon: faTrophy,
    title: "Nemzeti Bajnokok",
    description: "Pályázati támogatás nemzeti bajnok minősítésű vállalatoknak.",
    to: "/nemzeti-bajnokok",
  },
  {
    icon: faMapLocationDot,
    title: "Hátrányos helyzetű régiók",
    description: "Beruházási támogatás hátrányos helyzetű térségekben.",
    to: "/elmaradott-tersegek-tamogatasa",
  },
  {
    icon: faHandshake,
    title: "Partnerség",
    description: "Csatlakozz partnerprogramunkhoz és ajánlj ügyfeleket.",
    to: "/penzugyi-orangyal",
  },
];

export default function VallalatiHome() {
  return (
    <>
      <Container className="px-1 hero mx-md-auto">
        <span className="badge">FÜGGETLEN • SIKERDÍJAS • SZAKÉRTŐ</span>

        <h1 className="title">
          Találd meg a megfelelő <br />
          <span style={{ color: "#c7d2fe" }}>hitelt és pályázatot</span>
        </h1>

        <p className="subtitle">
          Intézd vállalkozásod pénzügyeit egy független szakértővel – a
          kalkulációtól a szerződéskötésig. Segítünk megtalálni a
          legkedvezőbb megoldásokat, tiszta sikerdíjas alapon.
          <br />
          <span className="fw-bold">
            Egy megkeresés, több banki és pályázati lehetőség.
          </span>
        </p>

        <div className="cta">
          <Button href="#leadform" className="btn btn-primary">
            Ajánlatot kérek
          </Button>

          <Button href="#szolgaltatasok" className="btn btn-secondary">
            Szolgáltatások megtekintése
          </Button>
        </div>
      </Container>

      <Container>
        <section id="szolgaltatasok" className="section">
          <h2 className="h2">Miben segítünk?</h2>
          <p className="lead mb-4">
            Válaszd ki, mire van szükséged – a kalkulációtól a
            szerződéskötésig végigkísérünk.
          </p>

          <TileGrid items={SERVICES} />
        </section>

        <section id="miert-mi" className="section">
          <h2 className="h2">Miért válaszd a Financials.hu-t?</h2>
          <p className="lead">
            Szolgáltatásaink kizárólag sikerdíjas alapon működnek, így csak
            akkor kell fizetned, ha valódi eredményt érünk el.
          </p>

          <Row className="g-4 mt-2">
            <Col md={6}>
              <ul className="list check-list">
                <li className="mb-4">
                  <FontAwesomeIcon icon={faCheck} className="me-3" />
                  <div>
                    <strong>Független szakértők:</strong> Több céggel
                    működünk együtt azért, hogy a legjobb megoldást találjuk.
                  </div>
                </li>
                <li className="mb-4">
                  <FontAwesomeIcon icon={faCheck} className="me-3" />
                  <div>
                    <strong>Sikerdíjas modell:</strong> Csak az eredményért
                    fizetsz, nincs rejtett költség vagy előre fizetendő díj.
                  </div>
                </li>
              </ul>
            </Col>
            <Col md={6}>
              <ul className="list check-list">
                <li className="mb-4">
                  <FontAwesomeIcon icon={faCheck} className="me-3" />
                  <div>
                    <strong>Időmegtakarítás:</strong> Az adminisztrációt,
                    pályázati folyamatokat és pénzügyi dokumentációt mi
                    intézzük helyetted.
                  </div>
                </li>
                <li className="mb-4">
                  <FontAwesomeIcon icon={faCheck} className="me-3" />
                  <div>
                    <strong>Teljes körű megoldások:</strong> Egy kézben
                    tarthatod a céges hiteleket, támogatásokat és a
                    bankszámla optimalizálást.
                  </div>
                </li>
              </ul>
            </Col>
          </Row>
        </section>

        <ResultsSection />

        <Container id="leadform">
          <h2 className="h2">Kérjen ajánlatot még ma!</h2>
          <p className="lead small">
            Add meg az adataid, és hamarosan visszajelzünk a vállalkozásod
            számára legkedvezőbb lehetőségekről.
          </p>
          <Row>
            <Col md={4}>
              <FormSection formType="Vállalati kapcsolatfelvétel" />
            </Col>
            <Col md={7} className="ms-md-5 ps-md-5 pt-2">
              <ul className="list check-list mt-3">
                <li className="mb-3">
                  <FontAwesomeIcon
                    icon={faCheck}
                    className="mb-2"
                    style={{ fontSize: "20px" }}
                  />
                  <h4>Díjmentes tanácsadás</h4>
                </li>
                <li className="mb-3">
                  <FontAwesomeIcon
                    icon={faCheck}
                    className="mb-2"
                    style={{ fontSize: "20px" }}
                  />
                  <h4>Több bank és pályázat egy helyen</h4>
                </li>
                <li className="mb-3">
                  <FontAwesomeIcon
                    icon={faCheck}
                    className="mb-2"
                    style={{ fontSize: "20px" }}
                  />
                  <h4>Sikerdíjas, kockázatmentes modell</h4>
                </li>
                <li className="mb-3">
                  <FontAwesomeIcon
                    icon={faCheck}
                    className="mb-2"
                    style={{ fontSize: "20px" }}
                  />
                  <h4>Végigkísérünk a szerződéskötésig</h4>
                </li>
              </ul>
            </Col>
          </Row>
        </Container>

        <section id="faq" className="section pb-0">
          <h2 className="h2">Gyakran ismételt kérdések</h2>

          <Faq
            categories={[
              {
                key: "altalanos",
                label: "Általános",
                items: [
                  {
                    question: "Mennyibe kerül a szolgáltatás?",
                    answer:
                      "Az ajánlatkérés, a bankok és pályázati lehetőségek feltérképezése, valamint a teljes körű ügyintézés díjmentes — kizárólag sikerdíjas alapon dolgozunk.",
                  },
                  {
                    question: "Milyen vállalati ügyekben tudnak segíteni?",
                    answer:
                      "Duális képzési programoktól a vállalati hitelen és számlaoptimalizáláson át a pályázati támogatásokig (Nemzeti Bajnokok, hátrányos helyzetű térségek) teljes körű segítséget nyújtunk.",
                  },
                  {
                    question: "Mennyi idő alatt kapok visszajelzést?",
                    answer:
                      "Az űrlap elküldése után munkatársunk hamarosan felveszi veled a kapcsolatot, és egyeztet a vállalkozásod számára legkedvezőbb lehetőségekről.",
                  },
                ],
              },
            ]}
          />
        </section>
      </Container>
    </>
  );
}
